










import { Prop, Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { v4 as uuid } from 'uuid'

@Component
export default class BracketSeparator extends Vue {
    @Prop({ type: HTMLElement }) readonly origin!: HTMLElement
    @Prop({ type: HTMLElement }) readonly target!: HTMLElement
    @Prop({ type: Number, default: 0 }) readonly marginTop!: number
    @Prop({ type: Number, default: 0 }) readonly marginBottom!: number
    @Ref('parent') parent!: HTMLDivElement

    targetHeight = 0
    originPositionY = 0
    parentPositionY = 0
    updateVersion = uuid()

    @Ref('middleLine') middleLine!: HTMLDivElement
    @Ref('originLine') originLine!: HTMLDivElement
    @Ref('originMiddleLine') originMiddleLine!: HTMLDivElement
    @Ref('targetTopLine') targetTopLine!: HTMLDivElement
    @Ref('targetBottomLine') targetBottomLine!: HTMLDivElement

    get componentClass() {
        return {
            'bracket-separator': true,
        }
    }

    mounted() {
        this.updateTarget()
        this.updateOrigin()

        const observer = new ResizeObserver(() => {
            this.updateVersion = uuid()
        })

        observer.observe(this.origin)
        observer.observe(this.target)
    }

    @Watch('origin')
    updateOrigin() {
        this.updateVersion = uuid()
    }

    @Watch('target')
    updateTarget() {
        this.updateVersion = uuid()
    }

    @Watch('updateVersion')
    renderBrackets() {
        if (this.parent) {
            this.parentPositionY = this.parent.getBoundingClientRect().top
        }

        if (this.target) {
            this.targetHeight = this.target.getBoundingClientRect().bottom - this.target.getBoundingClientRect().top
        }

        if (this.origin) {
            this.originPositionY = this.origin.getBoundingClientRect().top
        }

        this.middleLine.style.position = 'absolute'
        this.middleLine.style.top = this.marginTop.toString() + 'px'
        this.middleLine.style.height = (this.targetHeight - this.marginTop - this.marginBottom).toString() + 'px'
        this.middleLine.style.left = (this.parent.clientWidth / 2 - 1).toString() + 'px'
        this.middleLine.style.width = '2px'
        this.middleLine.style.backgroundColor = '#ccc'

        this.originMiddleLine.style.position = 'absolute'
        this.originMiddleLine.style.top = (this.targetHeight - 2 - this.marginBottom).toString() + 'px'
        this.originMiddleLine.style.height = ((this.originPositionY - this.parentPositionY + 24) - (this.targetHeight - this.marginBottom)).toString() + 'px'
        this.originMiddleLine.style.left = (this.parent.clientWidth / 2 - 1).toString() + 'px'
        this.originMiddleLine.style.width = '2px'
        this.originMiddleLine.style.backgroundColor = '#ccc'

        this.originLine.style.position = 'absolute'
        this.originLine.style.top = (this.originPositionY - this.parentPositionY + 20).toString() + 'px'
        this.originLine.style.height = '2px'
        this.originLine.style.width = (this.parent.clientWidth / 2).toString() + 'px'
        this.originLine.style.left = '0'
        this.originLine.style.backgroundColor = '#ccc'

        this.targetTopLine.style.position = 'absolute'
        this.targetTopLine.style.backgroundColor = '#ccc'
        this.targetTopLine.style.top = this.marginTop.toString() + 'px'
        this.targetTopLine.style.height = '2px'
        this.targetTopLine.style.right = (this.parent.clientWidth / 4).toString() + 'px'
        this.targetTopLine.style.width = (this.parent.clientWidth / 4).toString() + 'px'

        this.targetBottomLine.style.position = 'absolute'
        this.targetBottomLine.style.backgroundColor = '#ccc'
        this.targetBottomLine.style.top = (this.targetHeight - 2 - this.marginBottom).toString() + 'px'
        this.targetBottomLine.style.height = '2px'
        this.targetBottomLine.style.right = (this.parent.clientWidth / 4).toString() + 'px'
        this.targetBottomLine.style.width = (this.parent.clientWidth / 4).toString() + 'px'
    }
}


